/**
 * 电子宠物流式 API —— 跟客服同一套 SSE(`streamChatAt`),但打 `/pet/chat`、用**独立**
 * 的会话 id(localStorage key 跟客服分开 → 记忆/历史互不串;后端 iris 也走另一个 host)。
 *
 * 后端双门控:`pet_companion` 能力(未开通 403 capability_not_enabled)+
 * `ai_quotas` 日/月双限(用尽 402 pet_quota_exhausted)。
 */
import { apiRequest } from './client'
import { streamChatAt, type StreamChatOptions } from './support'

const SESSION_KEY = 'fabric.pet_session'

/** GET /api/v1/pet/state —— 跟 fabric-server::routes::pet::PetStateResp 对齐。 */
export interface PetState {
  /** 心情档(全程隐式,只给档不给数值):good / normal / bad。 */
  mood_tier: 'good' | 'normal' | 'bad'
  /** 蜕壳成长尺寸倍率:1.2 → 1.6(出生即 1.2×,每 2 个月 +0.2,蜕 2 次封顶)。 */
  scale: number
  /** 已蜕壳次数(0–2);前端比对 localStorage 决定要不要播蜕壳动画。 */
  molt_count: number
}

/** 取小蟹当前心情档 + 成长尺寸(纯读,后端已结算冷落衰减)。 */
export function fetchPetState(): Promise<PetState> {
  return apiRequest<PetState>('/pet/state')
}

function newSessionId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `p-${Date.now()}-${Math.random().toString(36).slice(2)}`
}

/** 取(或首次生成)电子宠物的稳定会话 id —— 跟客服分开。 */
export function petSessionId(): string {
  let sid = localStorage.getItem(SESSION_KEY)
  if (!sid) {
    sid = newSessionId()
    localStorage.setItem(SESSION_KEY, sid)
  }
  return sid
}

/** 开新对话:换 pet session id,iris 侧旧历史不再注入。返回新 id。 */
export function resetPetSession(): string {
  const sid = newSessionId()
  localStorage.setItem(SESSION_KEY, sid)
  return sid
}

/** 向 `/pet/chat` 发起流式提问(复用客服那套 SSE 解析)。 */
export function streamPetChat(opts: StreamChatOptions): Promise<void> {
  return streamChatAt('/pet/chat', opts)
}
